<script setup>


import moment from 'moment';
import {
    ElCol,
    ElRow,
    ElCard,
    ElText,
    ElButton,
    ElSlider,
    ElCheckboxGroup,
    ElCheckboxButton,
    ElCheckbox,
    ElLoading
} from "element-plus";
import axios from "axios";
import {ref} from "vue";
import FlightComboDetailsCard from "./FlightComboDetailsCard.vue";
import { formatMoney } from '../../../../utils/money';



const props = defineProps({
    flight:Object,
    editable: {
        type: Boolean,
        default: false,
        required: false
    }
});
const emit = defineEmits(['addflight','removeflight']);
const flight=props.flight;

const editable=props.editable;

const showdetails=ref(false);
const editprice=ref(false);

const momenttime=(date)=>{
    return moment(date).format('HH:mm');
}

const momentdate=(date)=>{
    return moment(date).format('D MMM');
}

const mintoHM=(totalMinutes)=>{
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    return hours+"h "+minutes+"m ";
}

const addflight=(flight)=>{
    emit('addflight',flight)
}

const removeflight=(flight)=>{
    emit('removeflight',flight)
}

</script>

<template>
    <el-card class="mt-3">
        <el-row :gutter="40">
            <el-col :span="10">
                <el-row class="flight-card" :gutter="20">
                    <el-col :span="6">
                        <div class="airlines">
                    <span v-for="airline in flight.departure.airlines" >
                    <img :src="'https://www.pickotrip.com/images/airlines-logo/'+airline.code+'.svg'" />
                    {{ airline.name }}&nbsp;
                    </span>
                        </div>
                    </el-col>
                    <el-col :span="6" class="timings text-right">
                <span>
                    <p>
                        <el-text tag="b" size="large">{{ momenttime(flight.departure.departure_datetime) }}</el-text>
                    </p>
                     <p>
                        <el-text tag="b" size="small">{{ momentdate(flight.departure.departure_datetime) }}</el-text>
                    </p>
                     <p>
                        <el-text tag="b" size="small">{{ flight.departure.from.city }}, {{ flight.departure.from.code }}</el-text>
                    </p>
                      <p>
                        <el-text  size="small"> {{ flight.departure.from.terminal }}</el-text>
                    </p>
                </span>
                    </el-col>
                    <el-col :span="6" class="duration text-center">
                        <p>
                            <el-text tag="b" size="small">{{ mintoHM(flight.departure.duration) }}</el-text>
                        </p>
                        <el-divider></el-divider>
                        <p class="stopsinfo">
                            <el-text tag="b" size="small">{{ flight.departure.layoverinfo }}</el-text>
                        </p>

                    </el-col>

                    <el-col :span="6" class="timings">
                <span>
                    <p>
                        <el-text tag="b" size="large">{{ momenttime(flight.departure.arrival_datetime) }}</el-text>
                    </p>
                     <p>
                        <el-text tag="b" size="small">{{ momentdate(flight.departure.arrival_datetime) }}</el-text>
                    </p>
                     <p>
                        <el-text tag="b" size="small">{{ flight.departure.to.city }}, {{ flight.departure.to.code }}</el-text>
                    </p>
                      <p>
                        <el-text  size="small"> {{ flight.departure.to.terminal }}</el-text>
                    </p>
                </span>
                    </el-col>
                </el-row>
            </el-col>
            <el-col :span="10">
                <el-row class="flight-card" :gutter="20">
                    <el-col :span="6">
                        <div class="airlines">
                    <span v-for="airline in flight.return.airlines" >
                    <img :src="'https://www.pickotrip.com/images/airlines-logo/'+airline.code+'.svg'" />
                    {{ airline.name }}&nbsp;
                    </span>
                        </div>
                    </el-col>
                    <el-col :span="6" class="timings text-right">
                <span>
                    <p>
                        <el-text tag="b" size="large">{{ momenttime(flight.return.departure_datetime) }}</el-text>
                    </p>
                      <p>
                        <el-text tag="b" size="small">{{ momentdate(flight.return.departure_datetime) }}</el-text>
                    </p>
                     <p>
                        <el-text tag="b" size="small">{{ flight.return.from.city }}, {{ flight.return.from.code }}</el-text>
                    </p>
                      <p>
                        <el-text  size="small"> {{ flight.return.from.terminal }}</el-text>
                    </p>
                </span>
                    </el-col>
                    <el-col :span="6" class="duration text-center">
                        <p>
                            <el-text tag="b" size="small">{{ mintoHM(flight.return.duration) }}</el-text>
                        </p>
                        <el-divider></el-divider>
                        <p class="stopsinfo">
                            <el-text tag="b" size="small">{{ flight.return.layoverinfo }}</el-text>
                        </p>

                    </el-col>

                    <el-col :span="6" class="timings">
                <span>
                    <p>
                        <el-text tag="b" size="large">{{ momenttime(flight.return.arrival_datetime) }}</el-text>
                    </p>
                      <p>
                        <el-text tag="b" size="small">{{ momentdate(flight.return.arrival_datetime) }}</el-text>
                    </p>
                     <p>
                        <el-text tag="b" size="small">{{ flight.return.to.city }}, {{ flight.return.to.code }}</el-text>
                    </p>
                      <p>
                        <el-text  size="small"> {{ flight.return.to.terminal }}</el-text>
                    </p>
                </span>
                    </el-col>
                </el-row>
            </el-col>
            <el-col :span="4">
                <el-dropdown trigger="hover">
                    <el-text tag="b" size="large">₹ {{formatMoney(flight.pricedetails.totalfare)}} <el-text tag="b" size="small" type="info" v-if="editable" @click="editprice=true">Edit</el-text></el-text>

                    <template #dropdown>
                            <p v-for="(det,key) in flight.pricedetails.fares">
                                {{key}} - ₹  {{formatMoney(det)}}
                            </p>
                    </template>
                </el-dropdown>
               <p>
                   <el-text size="small" type="success" v-if="flight.pricedetails.refundable">Refundable</el-text>
                   <el-text size="small" v-else type="danger">Non Refundable</el-text>
               </p>
                <p> <el-text tag="b" size="small" type="warning">{{ flight.pricedetails.baggage.checkin }}</el-text>
                </p>
                 <p><el-text tag="ins" @click="showdetails = true">Flight Details</el-text></p>
                <el-button type="danger" size="small" @click="removeflight(flight)" v-if="editable">Remove</el-button>
                <el-button type="primary" size="small" @click="addflight(flight)" v-else>Add Flight</el-button>
            </el-col>
        </el-row>
    </el-card>


    <el-dialog
        v-model="showdetails"
        title="Flight Details"
        width="80%"

    >
        <el-text size="small" type="success" v-if="flight.pricedetails.refundable">Refundable</el-text>
        <el-text size="small" v-else type="danger">Non Refundable</el-text>
        <flight-combo-details-card :flight="flight.departure"></flight-combo-details-card>
        <br>
        <flight-combo-details-card :flight="flight.return"></flight-combo-details-card>

    </el-dialog>

    <el-dialog
        v-model="editprice"
        title="Edit Price"
        width="50%"

    >

    </el-dialog>
</template>

<style scoped>

</style>
